<template>
    <v-dialog
        ref="dialog"
        v-model="addOpeningPeriodDialog"
        persistent
        content-class="pro-dialog"
        style="z-index:565645454545455"
        width="660px">
        <v-card :style="'font-family:' + fontFamily" v-if="currentOpeningPeriod !== null">
            <v-card-title style="margin-bottom: 20px">
                <span style="font-size: 1.5rem; font-weight: 400"
                      v-if="!isEditMode">
                    Ajout d'une période d'ouverture
                </span>
                <span style="font-size: 1.5rem; font-weight: 400"
                      v-else>
                    Modification d'une période d'ouverture
                </span>

                <v-btn icon
                       class="close-modal-icon"
                       @click="closeDialog()">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <div class="d-flex justify-start">
                    <div class="mr-5">
                        <label>Date de début</label>
                        <v-text-field
                            :value="dateStartFr"
                            readonly
                            style="padding-top: 0 !important"
                            @click="openPicker('dateStart')"
                            outlined
                        >
                        </v-text-field>
                    </div>

                    <div>
                        <label>Date de fin</label>
                        <v-text-field
                            :value="dateStopFr"
                            readonly
                            style="padding-top: 0 !important"
                            @click="openPicker('dateStop')"
                            outlined
                        >
                        </v-text-field>
                    </div>
                </div>

                <div>
                    <v-radio-group
                        v-model="currentOpeningPeriod.h24"
                        class="mt-auto mb-auto"
                        style="padding-top: 0 !important"
                    >
                        <v-radio
                            :color="primaryColor"
                            label="L'établissement est ouvert 24h/24 et 7j/7"
                            :value="true"
                        ></v-radio>
                        <v-radio
                            :color="primaryColor"
                            label="L'établissement est ouvert à certains horaires"
                            :value="false"
                        ></v-radio>
                    </v-radio-group>
                </div>

                <div class="w-100"
                       v-if="!currentOpeningPeriod.h24">
                    <div v-for="day in currentOpeningPeriod.opening_days"
                        class="d-md-flex mt-2">
                        <div style="width: 140px">
                            <div class="d-flex">
                                <div>
                                    <v-checkbox
                                        class="mt-0 mr-2"
                                        style="padding-top: 0 !important"
                                        :color="primaryColor"
                                        v-model="day.closed"
                                        :true-value="false"
                                        :false-value="true"
                                        @change="updateClosed(day)"
                                        hide-details
                                    >
                                    </v-checkbox>
                                </div>
                                <div
                                    class="mt-auto mb-auto"
                                    style="font-size: 15px">
                                    {{ daysOfWeek[day.day_of_week] }}
                                </div>
                            </div>
                        </div>
                        <div v-if="!day.closed"
                            class="d-flex mb-2">
                            <el-time-select
                                v-model="day.opening_hours[0].open"
                                placeholder="--:--"
                                class="mr-2"
                                style="width: 100px"
                                :picker-options="{
                                    step: '00:15',
                                    start: '00:00',
                                    end: '23:45',
                                }"
                                @change="updateTime($event, day.opening_hours[0], 'open')"
                            >
                            </el-time-select>

                            <el-time-select
                                v-model="day.opening_hours[0].close"
                                placeholder="--:--"
                                style="width: 100px"
                                :picker-options="{
                                    step: '00:15',
                                    start: '00:00',
                                    end: '23:45',
                                }"
                                @change="updateTime($event, day.opening_hours[0], 'close')"
                            >
                            </el-time-select>
                        </div>
                        <div
                            v-else
                            class="text-center mt-auto mb-auto"
                            colspan="2">
                            L'établissement est fermé ce jour
                        </div>
                        <div
                            v-if="day.opening_hours.length > 1 && !day.closed"
                            class="d-flex">
                            <div style="font-size: 22px"
                                class="ml-5 mr-5 mt-auto mb-auto d-none d-md-flex">/</div>
                            <el-time-select
                                v-model="day.opening_hours[1].open"
                                placeholder="--:--"
                                class="mr-2"
                                style="width: 100px"
                                :picker-options="{
                                    step: '00:15',
                                    start: '00:00',
                                    end: '23:45',
                                }"
                                @change="updateTime($event, day.opening_hours[1], 'open')"
                            >
                            </el-time-select>

                            <el-time-select
                                v-model="day.opening_hours[1].close"
                                placeholder="--:--"
                                style="width: 100px"
                                :picker-options="{
                                    step: '00:15',
                                    start: '00:00',
                                    end: '23:45',
                                }"
                                @change="updateTime($event, day.opening_hours[1], 'close')"
                            >
                            </el-time-select>
                        </div>
                        <div v-if="day.opening_hours.length === 1 &&
                                   !day.closed &&
                                   day.opening_hours[0].open !== null &&
                                   day.opening_hours[0].close !== null">
                            <v-btn text
                                   @click="addHours(day)"
                                   color="primaryColor"
                                   class="text-none ml-3">
                                <v-icon class="mr-2">add</v-icon>
                                Ajouter une plage horaire
                            </v-btn>
                        </div>
                    </div>
                </div>

                <div class="mt-5"
                     v-if="hasField('COMPLEMENT_OUVERTURE')">
                    <label :class="{'required': getField('COMPLEMENT_OUVERTURE').required}">Complément horaire</label>
                    <v-textarea
                        class="textarea"
                        hide-details
                        height="100px !important"
                        v-model="currentOpeningPeriod.description"
                        outlined>
                    </v-textarea>
                </div>

                <v-alert
                    type="error"
                    class="mt-5"
                    v-if="message !== null">
                    {{ message }}
                </v-alert>
            </v-card-text>

            <v-card-actions class="text-center">
                <div class="w-100 text-center">
                    <v-btn
                        class="text-none mb-4"
                        v-if="!isEditMode"
                        @click="addPeriod()"
                        :color="primaryColor"
                        :disabled="message !== null || dateStart === null || dateStop == null"
                        style="border-radius: 20px; color: white">
                        <v-icon class="mr-2">add</v-icon>
                        Ajouter
                    </v-btn>

                    <v-btn
                        class="text-none mb-4"
                        v-else
                        @click="updatePeriod"
                        :color="primaryColor"
                        :disabled="message !== null || dateStart === null || dateStop == null"
                        style="border-radius: 20px; color: white">
                        Enregistrer
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>

        <v-dialog
            ref="dialog"
            v-model="showPicker"
            persistent
            width="290px">
            <v-date-picker
                locale="fr-FR"
                color="primary"
                v-model="selectedDate"
                @input="setDatePicker"
                :first-day-of-week="1">
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="showPicker = false">Annuler</v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="showPicker = false">Valider</v-btn>
            </v-date-picker>
        </v-dialog>
    </v-dialog>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex"
import moment from "moment"
import da from "element-ui/src/locale/lang/da"

export default {
    name: "AddPeriodModal",

    data() {
        return {
            dateStart: null,
            dateStop: null,
            selectedDateProperty: null,
            selectedDate: null,
            showPicker: false,
            daysOfWeek: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"]
        }
    },
    methods: {
        ...mapMutations('web_form', ['setAddOpeningPeriodDialog', 'setCurrentOpeningPeriod', 'setEmptySuggestedOpeningDays',
        'setOpeningTabDirty',]),
        openPicker(property) {
            this.selectedDateProperty = property
            this.showPicker = true
        },
        setDatePicker(value) {
            this[this.selectedDateProperty] = value
        },
        closeDialog() {
            this.setCurrentOpeningPeriod(null)
            this.setAddOpeningPeriodDialog(false)

            this.dateStart = null
            this.dateStop = null
        },
        addPeriod() {
            this.currentOpeningPeriod.valid_from = this.dateStart
            this.currentOpeningPeriod.valid_through = this.dateStop

            let periods = this.provider.opening_periods
            periods.push(this.currentOpeningPeriod)
            periods.sort((p1, p2) => p2.valid_from - p1.valid_from)

            this.provider.opening_periods = periods

            if (this.currentOpeningPeriod.suggestion !== undefined) {
                this.setEmptySuggestedOpeningDays()
            }

            this.setOpeningTabDirty(true)
            this.closeDialog()
        },
        updatePeriod() {
            this.currentOpeningPeriod.valid_from = this.dateStart
            this.currentOpeningPeriod.valid_through = this.dateStop

            this.provider.opening_periods.forEach((period, index) => {
                if (period.uid === this.currentOpeningPeriod.uid) {
                    this.$set(this.provider.opening_periods, index, this.currentOpeningPeriod)
                }
            })

            if (this.currentOpeningPeriod.suggestion !== undefined) {
                this.setEmptySuggestedOpeningDays()
            }

            this.setOpeningTabDirty(true)
            this.closeDialog()
        },
        updateClosed(day) {
            if (day.opening_hours === undefined) {
                this.$set(day, "opening_hours", [])
            }

            if (!day.closed && day.opening_hours.length === 0) {
                this.addHours(day)
            }

            if (day.closed) {
                day.opening_hours = []
            }
        },
        addHours(day) {
            let createNew = false

            if (day.opening_hours === undefined) {
                this.$set(day, "opening_hours", [])
            }

            if (!day.opening_hours.length) {
                let lastDayIndexWithHours = this.getLastDayIndexWithHours(day)

                if (lastDayIndexWithHours !== null) {
                    let lastDay = this.currentOpeningPeriod.opening_days[lastDayIndexWithHours]

                    if (lastDay.opening_hours.length) {
                        lastDay.opening_hours.forEach((range) => {
                            let hour = {}

                            this.$set(hour, "open", range.open)
                            this.$set(hour, "close", range.close)

                            day.opening_hours.push(hour)
                        })
                    }
                } else {
                    createNew = true
                }
            } else {
                createNew = true
            }

            if (createNew) {
                let hours = {}

                this.$set(hours, "open", null)
                this.$set(hours, "close", null)

                day.opening_hours.push(hours)
            }

            day.closed = false
        },
        getLastDayIndexWithHours(day) {
            let median = null
            let i = null

            this.currentOpeningPeriod.opening_days.forEach((_day, index) => {
                if (_day === day) {
                    median = index
                }
            })

            this.currentOpeningPeriod.opening_days.forEach((_day, index) => {
                if (index < median && _day.opening_hours !== undefined && _day.opening_hours.length) {
                    i = index
                }
            })

            return i >= 0 ? i : null
        },
        updateTime(e, hour, property) {
            hour[property] = e
        },
        formatHour(hour) {
            let splited = hour.split(":")
            hour = splited[0] + ":" + splited[1]
            return hour
        },
    },
    watch: {
        currentOpeningPeriod() {
            if (this.currentOpeningPeriod !== null) {
                this.dateStart = this.currentOpeningPeriod.valid_from
                this.dateStop = this.currentOpeningPeriod.valid_through

                this.currentOpeningPeriod.opening_days.forEach(day => {
                    day.opening_hours.forEach((hour) => {
                        if(hour.close !== null) {
                            hour.close = this.formatHour(hour.close)
                        }

                        if(hour.open !== null) {
                            hour.open = this.formatHour(hour.open)
                        }
                    })
                })
            }
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'addOpeningPeriodDialog', 'currentOpeningPeriod']),
        ...mapState("webFormStyle", ["fontFamily", 'primaryColor']),
        ...mapGetters("web_form", ["hasField", 'getField']),
        da() {
            return da
        },
        dateStartFr() {
            if (!this.dateStart) {
                return null
            }

            return this.$moment(this.dateStart).format("DD/MM/YYYY")
        },
        dateStopFr() {
            if (!this.dateStop) {
                return null
            }

            return this.$moment(this.dateStop).format("DD/MM/YYYY")
        },
        isEditMode() {
            if (this.currentOpeningPeriod === null) {
                return false
            }

            return this.provider.opening_periods.find(period => period.valid_from === this.currentOpeningPeriod.valid_from) !== undefined
        },
        message() {
            let message = null

            if (this.dateStart > this.dateStop) {
                message = "La date de début doit précéder la date de fin"
            }

            this.provider.opening_periods.forEach((period) => {
                if (
                    period.uid !== this.currentOpeningPeriod.uid &&
                    ((this.dateStart >= period.valid_from && this.dateStart <= period.valid_through) ||
                        (this.dateStop >= period.valid_from && this.dateStop <= period.valid_through))
                ) {
                    message = "La période que vous créez actuellement recouvre une autre période"
                }
            })

            return message
        },
    }
}
</script>